Wee.fn.make('common', {
	init: function() {
		var priv = this.$private;

		NProgress.configure({
			showSpinner: false
		});

		priv.initHistory();

		$.screen.map([
			{
				callback: function() {
					priv.calculatePadding();
				}
			}
		]);
	},

	alert: function() {
		var scope = this,
			$main = $('ref:main');

		Wee.alert.top({
			cookieEnabled: false,
			enabledCallback: function() {
				$main.css('paddingTop', scope.$private.calculatePadding(true));
			},
			disabledCallback: function() {
				$main.css('paddingTop', scope.$private.calculatePadding());
			}
		});
	},

	unload: function() {
		$.events.off(false, '.winResize');
	}
}, {
	calculatePadding: function() {
		$('ref:main').css('paddingTop', $('ref:header').height() + 'px');
	},
	initHistory: function() {
		var scope = this;

		// Wee history
		$.history.init({
			bind: {
				click: 'a'
			},
			request: {
				send: function() {
					NProgress.start();

					loadTimer = setInterval(function() {
						NProgress.inc();
					}, 600);
				},
				complete: function() {
					clearInterval(loadTimer);

					NProgress.done();
				},
				success: function() {
					var $main = $('ref:main');

					// Check for top alert and adjust padding accordingly
					if ($('ref:weeTopAlert').isEnabled()) {
						$main.css('paddingTop', scope.calculatePadding(true));
					} else {
						$main.css('paddingTop', scope.calculatePadding());
					}
				},
				error: function(xhr) {
					$._win.location = xhr.responseURL;
				}
			},
			end: function() {
				ga('set', 'page', Wee.routes.uri().full);
				ga('send', 'pageview');
			}
		});
		// Disable mouse event outlines
		$('a').on('mousedown', function() {
			var $el = $(this);

			if ($el.css('outline-style') == 'none') {
				var outlineClass = '-no-outline';
				$el.addClass(outlineClass).on('blur', function() {
					$el.removeClass(outlineClass);
				}, {
					once: true
				});
			}
		}, {
			delegate: $._body
		});
	}
});